import React from "react";
import Modal from "../../../../../components/Modal";
import FormJobTitle from "./FormJobTitle";

interface ModalFormJobTitleProps {
  isOpen: boolean;
  setClose: (modalState: boolean) => void;
  value: any;
  onSubmit: (value: any) => void;
}

const ModalFormJobTitle = ({
  isOpen, setClose, onSubmit, value,
}: ModalFormJobTitleProps) => (
  <Modal
    isOpen={isOpen}
    setOpen={setClose}
    title={`${value?.id ? "Edit" : "Tambah"} data - job title`}
    body={
      <FormJobTitle defaultValue={value} onSubmit={onSubmit} onClose={() => setClose(false)} />
    }
  />
);

export default ModalFormJobTitle;
